import Lenis from 'lenis';
import { useEffect } from 'react';

import './App.css';
import Navbar from './components/Navbar';
import './index.css';
import Contact from './sections/Contact';
// import Education from './sections/Education';
import Home from './sections/Home';
import Products from './sections/Products';
import Services from './sections/Services';

const App = () => {
  // Initialize Lenis smooth scrolling
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 2,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <Home />
      <Products />
      <Services />
      {/* <Education /> */}
      <Contact />
      <footer className="relative z-20 bg-gray-100 border-t border-gray-200 py-6 sm:py-8 px-4 sm:px-6 text-center font-primary text-xs sm:text-sm text-gray-500">
        <p className="font-semibold text-gray-700">AR5 Labs LLC</p>
        <p>8 The Green Ste A, Dover, DE 19901</p>
        <p>ar5labs.com</p>
      </footer>
    </div>
  );
};

export default App;
